import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    'email',
    'telephone',
    'emailRequireError',
    'telRequireError',
    'emailFormatError',
    'telFormatError',
    'submitButton'
  ]

  connect() {
    this.controllSubmitButton()
  }

  // 必須項目のバリデーション
  requireEmailInvalid() {
    return this.emailTarget.value == ''
  }

  requireTelInvalid() {
    return this.telephoneTarget.value == ''
  }

  // 必須項目のエラー表示制御
  controllRequireEmailError() {
    this.emailRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireEmailInvalid()

    this.emailTarget.classList.toggle('regist_form__error_input', isInvalid)
    this.emailRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllReauireTelError() {
    this.telRequireErrorTarget.classList.add('regist_form__hide')

    const isInvalid = this.requireTelInvalid()

    this.telephoneTarget.classList.toggle('regist_form__error_input', isInvalid)
    this.telRequireErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  // フォーマットバリデーション
  formatEmailInvalid() {
    if (this.requireEmailInvalid()) { return false }

    const pattern = /^[A-Za-z0-9._+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
    
    return !pattern.test(this.emailTarget.value)
  }

  formatTelInvalid() {
    if (this.requireTelInvalid()) { return false }

    const pattern = /^(?:0[346]\d{8}|\d{11})$/;

    return !pattern.test(this.telephoneTarget.value)
  }

  controllFormatEmailError() {
    this.emailFormatErrorTarget.classList.add('regist_form__hide')

    if (this.requireEmailInvalid()) { return }

    const isInvalid = this.formatEmailInvalid()

    this.emailTarget.classList.toggle('regist_form__error_input', isInvalid)
    this.emailFormatErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  controllFormatTelError() {
    this.telFormatErrorTarget.classList.add('regist_form__hide')

    if (this.requireTelInvalid()) { return }

    const isInvalid = this.formatTelInvalid()

    this.telephoneTarget.classList.toggle('regist_form__error_input', isInvalid)
    this.telFormatErrorTarget.classList.toggle('regist_form__hide', !isInvalid)
  }

  // 入力補助
  // メールアドレスを全角から半角への変換
  convertEmailToHalfwidth() {
    const inputString = this.emailTarget.value
    const fullWidthCharacters = '＠－ー＋＿．，、';
    const halfWidthCharacters = '@--+_...';
    let convertedString = '';

    for (let i = 0; i < inputString.length; i++) {
      const dataChar = inputString.charAt(i);
      const dataNum = fullWidthCharacters.indexOf(dataChar, 0);
      if (dataNum >= 0) {
        convertedString += halfWidthCharacters.charAt(dataNum);
      } else {
        convertedString += dataChar;
      }
    }

    const hankaku = convertedString.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });

    this.emailTarget.value = hankaku;
  }

  // 数字を全角から半角へ変換
  convertNumberToHalfwidth() {
    const value = this.telephoneTarget.value;
    const inputString = value.trim();

    const convertedString = inputString.replace(/[０-９－ー]/g, (match) => {
      return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
    });

    return convertedString
  }

  // 電話番号に変換
  convertTelToHalfwidth() {
    const convertedString = this.convertNumberToHalfwidth();
    const cleanedString = convertedString.replace(/[-‐−–—﹣‑－‒]/g, '');
    this.telephoneTarget.value = cleanedString;
  }

  controllSubmitButton() {
    const isRequireInvalid = this.requireEmailInvalid() || this.requireTelInvalid()
    const isFormatInvalid = this.formatEmailInvalid() || this.formatTelInvalid()

    this.submitButtonTarget.disabled = isRequireInvalid || isFormatInvalid;
    this.submitButtonTarget.classList.toggle('regist_form__button--disabled', isRequireInvalid || isFormatInvalid);
  }
}
